
<amplify-authenticator errorMessage={map} class="d-flex justify-content-center mt-5" *ngIf="!user">
    <amplify-sign-up   header-text="Create a new account" slot="sign-up" [formFields]="formFields" class="d-flex justify-content-center mt-5">
    </amplify-sign-up>

    <amplify-sign-in  slot="sign-in" [formFields]="signInformFields"></amplify-sign-in>
</amplify-authenticator>

<p class="d-flex justify-content-center mt-5" *ngIf="user">You are already logged in</p>
